'use es6';

import SmartContentActivities from '../models/SmartContentActivities';
import { REQUESTED_SMART_CONTENT_DATA_CHECK, REQUESTED_SMART_CONTENT_DATA_CHECK_FAILED, RECIEVED_SMART_CONTENT_DATA_CHECK } from '../actions/ActionTypes';
import { RequestStatus } from '../constants/base';
export default ((state = new SmartContentActivities(), action) => {
  switch (action.type) {
    case REQUESTED_SMART_CONTENT_DATA_CHECK:
      return state.set('status', RequestStatus.PENDING);

    case RECIEVED_SMART_CONTENT_DATA_CHECK:
      return action.payload.data;

    case REQUESTED_SMART_CONTENT_DATA_CHECK_FAILED:
      return state.set('status', RequestStatus.FAILED);

    default:
      return state;
  }
});